export function IconCrown({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
    >
      <path
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
        strokeLinecap="round"
        d="M1 4.5l3.5 3L8 3l3.5 4.5 3.5-3-1.5 7h-11Z"
      />
    </svg>
  );
}
